import React from 'react';

/**
 * This is provided when an app has an unmapped entity app
 * This is different than a {@link PoppedUpEntityApp}, as the entity
 * is being directly consumed as opposed to "drilled down" to
 */
const V3EntityAppContext = React.createContext<
  | {
      selectedEntity: string;
      onEntitySelected: (newEntity: string) => void;
    }
  | undefined
>(undefined);

export default V3EntityAppContext;
